

























import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import logger from "@/modules/logger";

@Component({ name: "PageError" })
export default class PageError extends Vue {
  @Prop({ required: true })
  public readonly error!: Error;

  public errorDate: Date = new Date();

  public mounted() {
    logger.debug(this.error, undefined);
  }
}
